import { render } from "./Goods.html?vue&type=template&id=09412f49&ts=true&external"
import script from "./Goods.vue?vue&type=script&lang=ts"
export * from "./Goods.vue?vue&type=script&lang=ts"

import "./Goods.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__